import React from 'react';
import { useTranslation } from "react-i18next";

const CardPaymentPromissoryNote = ({ jsonMail }) => {
  const { t } = useTranslation("inscripcion");

  return (<div style={{ cursor: 'auto', color: '#000000', fontFamily: 'Ubuntu, Helvetica, Arial, sans-serif', fontSize: '13px', lineHeight: '22px', textAlign: 'center' }}>
    <p>
      {t("pagareTarjeta.declaracionPrefijo")}
       <b>{jsonMail.datos.statusPago.brand}</b> {t("pagareTarjeta.registradaConNombre")}
       <b>{jsonMail.datos.statusPago.cardName}</b> {t("pagareTarjeta.ultimosDigitos")}
       <b>{jsonMail.datos.statusPago.last4}</b>
      {t("pagareTarjeta.porUnMonto")} <b>{t("pagareTarjeta.monto", { monto: jsonMail.datos.statusPago.amount })}</b> {t("pagareTarjeta.aNombreDe")}
      <b>Dashport</b>
    </p>
  </div>);

}

export default CardPaymentPromissoryNote;